import { render, staticRenderFns } from "./ProductCardV2.vue?vue&type=template&id=56a2ecd2&"
import script from "./ProductCardV2.vue?vue&type=script&lang=js&"
export * from "./ProductCardV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports